import React from 'react';

import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

export const HeaderCell: React.FC<{ children: React.ReactNode; css?: SystemStyleObject }> = ({ children, css }) => (
  <Box role="columnheader" css={{ pb: 'space.150', pt: 'space.200', display: 'flex', width: '100%', ...css }}>
    {children}
  </Box>
);
